import { Component, Inject, Vue } from 'vue-property-decorator';
import { OLClickSelect } from '@/primary/webmapping/common/OLClickSelect';
import { ProjectSidebarVue } from '@/primary/template-right-bar/project-sidebar';
import { CountrySidebarVue } from '@/primary/template-right-bar/country-sidebar';

@Component({
  components: { CountrySidebarVue, ProjectSidebarVue },
})
export default class TemplateRightBarComponent extends Vue {
  expanded = false;
  countryId = '';
  projectId = -1;

  @Inject()
  countryOLSelect!: () => OLClickSelect;

  created() {
    this.countryOLSelect().onSelect(countryId => this.onSelect(countryId));
  }

  private onSelect(countryId: string | null) {
    this.projectId = -1;
    this.countryId = countryId || '';
    this.expanded = countryId !== null;
  }
}
